// extracted by mini-css-extract-plugin
export default {"Thumbnail":"PostDetailCard_Thumbnail__TYeGX"};